import React from "react";
import { Avatar } from "@mui/material";
import { Block, LockOpen, PictureAsPdf } from "@mui/icons-material";
import { NOTIFICATION_ICON } from "../constants";

function IconBubble({ bubbleClassName, children }) {
  return (
    <div
      data-testid="notification-icon-bubble"
      className={`flex items-center justify-center w-10 h-10 rounded-full shrink-0 ${bubbleClassName}`}
    >
      {children}
    </div>
  );
}

const ICON_RENDERERS = {
  [NOTIFICATION_ICON.PDF]: () => (
    <IconBubble bubbleClassName="bg-red-100">
      <PictureAsPdf className="text-red-500" fontSize="small" />
    </IconBubble>
  ),
  [NOTIFICATION_ICON.ACCESS_GRANTED]: () => (
    <IconBubble bubbleClassName="bg-green-100">
      <LockOpen className="text-green-600" fontSize="small" />
    </IconBubble>
  ),
  [NOTIFICATION_ICON.ACCESS_REVOKED]: () => (
    <IconBubble bubbleClassName="bg-red-100">
      <Block className="text-red-600" fontSize="small" />
    </IconBubble>
  ),
};

export function NotificationAvatar({ icon, letter }) {
  const Renderer = ICON_RENDERERS[icon];

  if (Renderer) return <Renderer />;

  return <Avatar className="!bg-secondaryColor w-fit">{letter}</Avatar>;
}
